import React from "react";
import { styled } from "@mui/material/styles";
import { COLORS } from "./constants";

const MyTable = ({ title, header, items }) => {
  console.log(items);
  return (
    <div>
      {title && <h3>{title}</h3>}
      <Table>
        <thead>
          <tr>
            {header
              ? header.map((h) => <Th>{h}</Th>)
              : Object.keys(items[0]).map((h) => <Th>{h}</Th>)}
          </tr>
        </thead>
        <tbody>
          {Object.values(items).map((item) => {
            return (
              <Tr>
                {Object.values(item).map((v) => {
                  if (typeof v === "string" || typeof v === "number")
                    return <Td>{v}</Td>;
                })}
              </Tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};

export default MyTable;

const Th = styled("th")({
  // border: "1px solid darkgray",
  padding: "9px",
  textAlign: "center",
  background: COLORS.GRID_HEADER_BACKGROUND,
  // color: "white",
  fontWeight: "normal",
});
const Td = styled("td")({
  // border: "1px solid darkgray",
  padding: "7px 40px",
  textAlign: "center",
});

const Tr = styled("tr")({
  borderBottom: "1px solid #ddd",
});

const Table = styled("table")({
  marginTop: "10px",
  fontSize: "0.8rem",
  borderCollapse: "collapse",
});
